// // src/utils/compressImage.js
// export async function compressImage(
//   file,
//   {
//     maxWidth = 1920,
//     maxHeight = 1920,
//     maxSizeMB = 0.7, // зорилтот MB (жишээ нь ~700KB)
//     mimeType = "image/jpeg", // гаралт JPEG болгочихъё (PNG -> JPEG бол илүү жижиг)
//     initialQuality = 0.9,
//     step = 0.1,
//   } = {}
// ) {
//   const img = await loadImageBitmapOrHTML(file);

//   // ✅ Харьцаа эвдэхгүйгээр багасгах
//   const { w, h } = fitContain(img.width, img.height, maxWidth, maxHeight);

//   const canvas =
//     "OffscreenCanvas" in window
//       ? new OffscreenCanvas(w, h)
//       : document.createElement("canvas");
//   canvas.width = w;
//   canvas.height = h;

//   const ctx = canvas.getContext("2d", { alpha: false });
//   ctx.drawImage(img, 0, 0, w, h);

//   let quality = initialQuality;
//   let blob = await toBlob(canvas, mimeType, quality);
//   const targetBytes = maxSizeMB * 1024 * 1024;

//   while (blob && blob.size > targetBytes && quality > step + 0.05) {
//     quality = Math.max(0.05, quality - step);
//     blob = await toBlob(canvas, mimeType, quality);
//   }

//   const ext = mimeType === "image/jpeg" ? "jpg" : "jpeg";
//   const out = new File([blob], renameExt(file.name, ext), {
//     type: mimeType,
//     lastModified: Date.now(),
//   });

//   if ("close" in img)
//     try {
//       img.close();
//     } catch {}
//   return out;
// }

// function fitContain(sw, sh, maxW, maxH) {
//   let w = sw,
//     h = sh;
//   if (w > maxW) {
//     const k = maxW / w;
//     w = Math.round(w * k);
//     h = Math.round(h * k);
//   }
//   if (h > maxH) {
//     const k = maxH / h;
//     w = Math.round(w * k);
//     h = Math.round(h * k);
//   }
//   return { w: Math.max(1, w), h: Math.max(1, h) };
// }

// async function loadImageBitmapOrHTML(file) {
//   if ("createImageBitmap" in window) return await createImageBitmap(file);
//   const dataUrl = await fileToDataURL(file);
//   const img = new Image();
//   img.decoding = "async";
//   img.src = dataUrl;
//   await img.decode();
//   return img;
// }
// function fileToDataURL(file) {
//   return new Promise((res, rej) => {
//     const fr = new FileReader();
//     fr.onload = () => res(fr.result);
//     fr.onerror = rej;
//     fr.readAsDataURL(file);
//   });
// }
// function toBlob(canvas, type, quality) {
//   return new Promise((resolve) => {
//     if ("convertToBlob" in canvas) {
//       canvas.convertToBlob({ type, quality }).then(resolve);
//     } else {
//       canvas.toBlob((b) => resolve(b), type, quality);
//     }
//   });
// }
// function renameExt(name, ext) {
//   const i = name.lastIndexOf(".");
//   const base = i > -1 ? name.slice(0, i) : name;
//   return `${base}.${ext}`;
// }

// src/utils/compressImage.js
export async function compressImage(
  file,
  {
    maxWidth = 1920,
    maxHeight = 1920,
    maxSizeMB = 0.7, // зорилтот дээд хэмжээ
    mimeType = "image/jpeg",
    initialQuality = 0.85, // 0.9-аас багаас эхлүүлье
    neverBiggerThanOriginal = true, // эхээсээ хэзээ ч томруулахгүй
  } = {}
) {
  const originalBytes = file.size;
  const img = await loadImageBitmapOrHTML(file);

  // 1) Харьцааг эвдэхгүйгээр хэмжээг багасгах (шаардлагатай бол)
  const { w, h, changed } = fitContain(
    img.width,
    img.height,
    maxWidth,
    maxHeight
  );

  const canvas =
    "OffscreenCanvas" in window
      ? new OffscreenCanvas(w, h)
      : document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;

  const ctx = canvas.getContext("2d", { alpha: false });
  ctx.drawImage(img, 0, 0, w, h);

  // 2) Зорилтот bytes = min(maxSizeMB, originalBytes) (хэзээ ч эхээсээ томруулахгүй)
  const targetBytes = neverBiggerThanOriginal
    ? Math.min(maxSizeMB * 1024 * 1024, originalBytes)
    : maxSizeMB * 1024 * 1024;

  // 3) Эхний оролдлого
  let bestBlob = await toBlob(canvas, mimeType, initialQuality);

  // Хэрэв resize хийгдээгүй бөгөөд эхний encode нь эхээсээ ТОМ бол, давхар кодлох хэрэггүй
  if (!changed && bestBlob.size >= originalBytes && neverBiggerThanOriginal) {
    if ("close" in img)
      try {
        img.close();
      } catch {}
    return file; // эх файлаа шууд буцаа
  }

  // 4) Хэрэв эхний оролдлого зорилтоос их байвал чанарыг binary search-ээр бууруул
  if (bestBlob.size > targetBytes) {
    const q = await binarySearchQuality(
      canvas,
      mimeType,
      targetBytes,
      0.4,
      initialQuality
    );
    bestBlob = await toBlob(canvas, mimeType, q);
  }

  // 5) Аюулгүйн шалгалт: хэрэв эцсийн blob нь эхээсээ том бол эхийг буцаа (аль жижигхэнийг сонгоно)
  if (neverBiggerThanOriginal && bestBlob.size >= originalBytes) {
    if ("close" in img)
      try {
        img.close();
      } catch {}
    return file;
  }

  const outExt =
    mimeType.endsWith("jpeg") || mimeType.endsWith("jpg") ? "jpg" : "jpeg";
  const outFile = new File([bestBlob], renameExt(file.name, outExt), {
    type: mimeType,
    lastModified: Date.now(),
  });

  if ("close" in img)
    try {
      img.close();
    } catch {}
  return outFile;
}

function fitContain(sw, sh, maxW, maxH) {
  let w = sw,
    h = sh;
  let changed = false;
  if (w > maxW) {
    const k = maxW / w;
    w = Math.round(w * k);
    h = Math.round(h * k);
    changed = true;
  }
  if (h > maxH) {
    const k = maxH / h;
    w = Math.round(w * k);
    h = Math.round(h * k);
    changed = true;
  }
  return { w: Math.max(1, w), h: Math.max(1, h), changed };
}

async function binarySearchQuality(
  canvas,
  type,
  targetBytes,
  low = 0.3,
  high = 0.9
) {
  // 6–7 алхам л хангалттай нарийвчлал
  for (let i = 0; i < 7; i++) {
    const mid = (low + high) / 2;
    const blob = await toBlob(canvas, type, mid);
    if (blob.size > targetBytes) {
      high = mid; // чанарыг бууруулна
    } else {
      low = mid; // чанарыг өсгөнө (илүү сайн чанартай, дахиад багтвал сайн)
    }
  }
  return low;
}

async function loadImageBitmapOrHTML(file) {
  if ("createImageBitmap" in window) return await createImageBitmap(file);
  const dataUrl = await fileToDataURL(file);
  const img = new Image();
  img.decoding = "async";
  img.src = dataUrl;
  await img.decode();
  return img;
}

function fileToDataURL(file) {
  return new Promise((res, rej) => {
    const fr = new FileReader();
    fr.onload = () => res(fr.result);
    fr.onerror = rej;
    fr.readAsDataURL(file);
  });
}

function toBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    if ("convertToBlob" in canvas) {
      canvas.convertToBlob({ type, quality }).then(resolve);
    } else {
      canvas.toBlob((b) => resolve(b), type, quality);
    }
  });
}

function renameExt(name, ext) {
  const i = name.lastIndexOf(".");
  const base = i > -1 ? name.slice(0, i) : name;
  return `${base}.${ext}`;
}
